import { useMemo } from 'react';
import { useUser } from 'client/hooks/user/useUser';
import { getUserInAdminUsers, getUserInRegisteredUsers } from 'common/services/userServices';

export function RequireAuthHideOnly({ children, alternate }: { children?: JSX.Element; alternate?: JSX.Element }) {
    const { user, isLoading } = useUser();
    const userRegistered = useMemo(() => getUserInRegisteredUsers(user), [user]);
    const userAdmin = useMemo(() => getUserInAdminUsers(user), [user]);

    if (isLoading) {
        return null;
    } else if (!user || (!userRegistered && !userAdmin)) {
        if (alternate) {
            return <>{alternate}</>;
        }

        return null;
    }

    return <>{children}</>;
}
